import { useState, } from 'react';
import { Col, Form, Row, Button, Card } from 'react-bootstrap';
import Reload from '../../../components/reload/reload';

function PasswordIniti(props) {
    const { loading, setLoading, handleConfirmPass } = props;

    const [pass, setPass] = useState({
        password1: ''
    })

    const handlePass = () => {
        handleConfirmPass(pass.password1)
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            setLoading(true)
            event.preventDefault();
            handleConfirmPass(pass.password1);
        }
    };

    return (
        <Card className="p-4" style={{ height: "100vh", background: "#0C392E", borderRadius: 0, textAlign: "center" }}>
            <h1 style={{ textAlign: "center", color: "#f4f4f4" }}>Loc Solution | Motomco</h1>
            {loading && <Reload />}
            <Form
                className='p-3 text-center'
                style={{
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: "28vh",
                    border: "solid 1px #198754",
                    borderRadius: "1rem"
                }}
            >
                <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword0">
                    <Col>
                        <Form.Control
                            value={pass.password1}
                            type="password"
                            placeholder="Senha"
                            onKeyDown={handleKeyDown}
                            onChange={event => {
                                setPass({ ...pass, password1: event.target.value });
                            }}
                        />
                    </Col>
                </Form.Group>

                <Button
                    className='w-100'
                    variant="success"
                    onClick={() => {
                        handlePass()
                    }}>
                    Carregar
                </Button>
            </Form>

        </Card>
    );
}

export default PasswordIniti;
